import {
  getRoadmapFilters,
  getRoadmapProjectList,
  getRoadmapProjectEpicList,
  getEpicIssueByProjectViewMode,
  getSprintByProjectViewMode,
  getSprintIssueByProjectViewMode,
  getVersionListByVersionViewMode,
  getEpicListByVersionViewMode,
  getSprintListByVersionViewMode,
  getEpicIssueListByVersionViewMode,
  getSprintIssueListByVersionViewMode,
  getRoadmapRelationship,
  getBatchProjectEpics,
  getBatchVersionEpics,
  getBatchProjectSprints,
  getBatchVersionSprints,
  getSubtaskListByIssueId
} from '@/api/roadmap';
import dayjs from 'dayjs';
const quarterOfYear = require('dayjs/plugin/quarterOfYear');
const weekOfYear = require('dayjs/plugin/weekOfYear');
dayjs.extend(quarterOfYear);
dayjs.extend(weekOfYear);
import { cloneDeep, groupBy, sortBy } from 'lodash';
import { getIssueTypeList, getEpicIssueTypeList } from '@/api/roadmap';

const DAY_WIDTH = {
  month: 10,
  week: 40,
  quarter: 4
};

const DATE_RANG = ['2019/01/01 00:00:00', '2026/12/31 11:59:59'];

const batchUpdates = new Set();
let timer = null;

const state = {
  scrollTop: 0, // 同步左右滚动条
  scrollLeft: 0,
  dateRange: ['2019/01/01 00:00:00', '2026/12/31 11:59:59'],
  dateList: [],
  filterOptions: {},
  filterSelected: {},
  // 扁平化存储展开的数据
  expands: [],
  projectView: {
    list: [],
    epic: {},
    sprint: {},
    issue: {},
    subtask: {}
  },
  versionView: {
    list: [],
    epic: {},
    sprint: {},
    issue: {},
    subtask: {}
  },
  projectViewLoadedRelationshipObj: {
    epic: {},
    sprint: {}
  }, //已经加载了关联关系的迭代或者史诗
  versionViewLoadedRelationshipObj: {
    epic: {},
    sprint: {}
  }, //已经加载了关联关系的迭代或者史诗
  relationShipDataList: [],
  currentDragSourceId: null,
  isDragging: false,
  // 扁平化存储需要更新的数据
  shouldUpdateUuids: [],
  dateType: null,
  addKey: null,
  projectIssueTypeMap: {},
  projectEpicIssueTypeMap: {},
  highLightItem: {},
  shouldAnimation: false,
  isRoadmap: false,
  horizontalScrollerClass: 'zk-gantt-horizontal-scroller',
  verticalScrollerClass: 'zk-gantt-vertical-scroller',
  activeProjectIds: [],
  lineDragging: false,
  holidays: null,
  loading: '', // loading的状态 'global' | 当前行的key
  loadingKeys: new Set()
};

const getters = {
  rootData(state) {
    return state.filterSelected.view === 'project' ? state.projectView : state.versionView;
  },
  itemView(){
    return state.filterSelected.item;
  },
  dayCellWidth(state) {
    return DAY_WIDTH[state.dateType];
  },
  dateRowWidth(state, getters) {
    return getters.headerList.reduce((pre, cur) => pre + cur.width, 0);
  },
  isExpand(state) {
    return uid => state.expands.includes(uid);
  },
  currentExpandLevelUuidList(state) {
    const { view, item } = state.filterSelected;
    return level => {
      return state.expands.filter(
        expandUid => {
          const isCurrentView = expandUid.startsWith(view);
          const isCurrentItem = expandUid.includes(item);
          return level === 0 ? isCurrentView : isCurrentView && isCurrentItem;
        }
      );
    };
  },
  currentExpandLevelIds(state, getters) {
    return level => {
      return getters.currentExpandLevelUuidList(level).map(
        expandUid => +expandUid.split('.').pop()
      );
    };
  },
  headerList(state, getters) {
    if (!state.dateList.length){
      const INIT_DATE_LIST = createDateList(DATE_RANG[0], DATE_RANG[1]);
      state.dateList = INIT_DATE_LIST;
    }
    if (!state.dateType){
      return [];
    }
    const dateList = state.dateList;
    const groupByDateType = groupBy(dateList, `year_${state.dateType}`);
    const list = Object.keys(groupByDateType).map(
      key =>{
        const firstItem = groupByDateType[key][0];
        return Object.freeze({
          ...firstItem,
          width: groupByDateType[key].length * getters.dayCellWidth
        });
      }
    );
    return Object.freeze(list);
  },
  list(state, getters) {
    let dataObj = {};
    const { view } = state.filterSelected;
    if (view === 'project') {
      dataObj = state.projectView;
    } else if (view === 'version') {
      dataObj = state.versionView;
    } else {
      return [];
    }

    let level0List = dataObj.list;
    if (!level0List?.length){
      return Object.freeze([]);
    }

    if (state.filterSelected.view === 'project' && state.activeProjectIds){
      level0List = sortBy(level0List, item => state.activeProjectIds.indexOf(item.id) > -1 ? 0 : 1);
    }

    const resultList = [];
    let nextTop = 0;
    const itemView = state.filterSelected.item;

    const formatAddLoadingItem = (item, type, nextTop) => {
      return Object.freeze({
        type: type,
        level: item.level + 1,
        size: SIZE[item.level + 1],
        data: item,
        top: nextTop,
        uid: `${item.key}_${type}`
      });
    };

    const checkIsLevel0HasChildren = (data) => {
      return itemView === 'epic' ? !!(data.epicCount || data.issueCount) : !!(data.sprintCount || data.issueCount);
    };

    const checkIsLevel1HasChildren = (data) => {
      return !!data.issueCount;
    };

    for (let i = 0; i < level0List.length; i++) {
      const level0 = { ...level0List[i] };
      level0.top = nextTop;
      resultList.push(Object.freeze(level0));
      nextTop += level0.size;
      //项目，版本层级展开状态
      if (getters.isExpand(level0.uid)) {
        const level1List = dataObj[itemView]?.[level0.id];
        if (level0.uid === state.addKey) {
          const addItem = formatAddLoadingItem(level0, 'add', nextTop);
          resultList.push(addItem);
          nextTop += addItem.size;
        }
        const isLevel0HasChildren = checkIsLevel0HasChildren(level0);
        if (!level1List?.length) {
        // 没有数据，则直接判断是否为loading状态
          if (isLevel0HasChildren) {
            const loadingItem = formatAddLoadingItem(level0, 'loading', nextTop);
            resultList.push(loadingItem);
            nextTop += loadingItem.size;
          }
        } else {
          // 有数据的情况
          for (let j = 0; j < level1List.length; j++) {
            const level1 = { ...level1List[j] };
            if (level1.type === 'empty' && (level0.uid === state.addKey || !isLevel0HasChildren)){
              continue;
            }
            level1.top = nextTop;
            resultList.push(Object.freeze(level1));
            nextTop += level1.size;
            if (getters.isExpand(level1.uid)) {
              const level2List = dataObj.issue?.[level1.key];
              if (level1.uid === state.addKey) {
                const addItem = formatAddLoadingItem(level1, 'add', nextTop);
                resultList.push(addItem);
                nextTop += addItem.size;
              }
              const isLevel1HasChildren = checkIsLevel1HasChildren(level1);
              if (!level2List?.length) {
                if (isLevel1HasChildren) {
                  const loadingItem = formatAddLoadingItem(level1, 'loading', nextTop);
                  resultList.push(loadingItem);
                  nextTop += loadingItem.size;
                }
              } else {
                for (let k = 0; k < level2List.length; k++) {
                  const level3Item = { ...level2List[k] };
                  if (level3Item.type === 'empty' && (level1.uid === state.addKey || !isLevel1HasChildren)){
                    continue;
                  }
                  level3Item.top = nextTop;
                  nextTop += level3Item.size;
                  resultList.push(Object.freeze(level3Item));
                  // Level 3: subtask expansion
                  if (state.filterSelected.showSubtask && level3Item.type === 'issue' && level3Item.subtaskCount > 0 && getters.isExpand(level3Item.uid)) {
                    const subtaskList = dataObj.subtask?.[level3Item.pathId];
                    if (!subtaskList?.length) {
                      const loadingItem = Object.freeze({
                        type: 'loading',
                        level: 3,
                        size: SIZE[3],
                        data: level3Item,
                        top: nextTop,
                        uid: `${level3Item.uid}_loading`
                      });
                      resultList.push(loadingItem);
                      nextTop += loadingItem.size;
                    } else {
                      for (let m = 0; m < subtaskList.length; m++) {
                        const subtaskItem = { ...subtaskList[m] };
                        subtaskItem.top = nextTop;
                        nextTop += subtaskItem.size;
                        resultList.push(Object.freeze(subtaskItem));
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return Object.freeze(resultList);
  },
  view(state) {
    return state.filterSelected.view;
  },
  getIssueTypeList(state) {
    return (type, projectId) => {
      if (!type || !projectId){
        return [];
      }
      if (type === 'epic'){
        return state.projectEpicIssueTypeMap[projectId] || [];
      }
      return state.projectIssueTypeMap[projectId] || [];
    };
  },
  currentRelationDataObj(state) {
    const { view, item } = state.filterSelected;
    if (!(view && item)) {
      return [];
    }
    const dataObj = state[`${view}ViewLoadedRelationshipObj`][item];
    const res = [];
    if (dataObj && typeof dataObj === 'object') {
      Object.keys(dataObj)?.forEach(id => {
        const issueIdRelationMap = dataObj[id]?.issueIdRelationMap;
        if (issueIdRelationMap && typeof issueIdRelationMap === 'object') {
          return Object.keys(issueIdRelationMap)?.forEach(issueId => {
            return res.push(issueIdRelationMap[issueId]);
          });
        }
      });
      return res.flat();
    }
    return [];
  }
};

const mutations = {
  SET_LOADiNG(state, loading) {
    state.loading = loading;
  },
  ADD_LOADING_KEY(state, key) {
    if (state.loadingKeys.has(key)){
      return;
    }
    state.loadingKeys.add(key);
    state.loadingKeys = cloneDeep(state.loadingKeys);
  },
  REMOVE_LOADING_KEY(state, key) {
    if (!state.loadingKeys.has(key)){
      return;
    }
    state.loadingKeys.delete(key);
    state.loadingKeys = cloneDeep(state.loadingKeys);
  },
  SET_HOLIDAYS(state, holidays){
    state.holidays = holidays || new Set();
  },
  SET_ACTIVE_PROJECT_IDS(state, projectIds){
    state.activeProjectIds = projectIds || [];
  },
  SET_SCROLLTOP(state, scrollTop) {
    state.scrollTop = scrollTop;
  },
  SET_SCROLLLEFT(state, scrollLeft) {
    state.scrollLeft = scrollLeft;
  },
  SET_ELEMENT_SCROLLLEFT(state, { scrollLeft, smooth }){
    const el = document.querySelector(`.${state.horizontalScrollerClass}`);
    if (!el){
      return;
    }
    el.scrollTo({ left: scrollLeft, behavior: smooth ? 'smooth' : undefined });
  },
  SET_FILTER_OPTIONS(state, data) {
    state.filterOptions = data;
  },
  SET_FILTER_SELECTED(state, data) {
    state.filterSelected = { ...data };
  },
  SET_ADD_KEY(state, value){
    state.addKey = value;
  },
  CLEAR_STATE(state) {
    state.scrollLeft = 0;
    //state.scrollTop = 0;
    // state.projectView = Object.assign({}, state.projectView, {
    //   epic: {},
    //   sprint: {},
    //   issue: {}
    // });
    // state.versionView = Object.assign({}, state.versionView, {
    //   epic: {},
    //   sprint: {},
    //   issue: {}
    // });
    state.versionViewLoadedRelationshipObj = Object.assign({}, state.versionViewLoadedRelationshipObj, {
      epic: {},
      sprint: {}
    });
    state.projectViewLoadedRelationshipObj = Object.assign({}, state.projectViewLoadedRelationshipObj, {
      epic: {},
      sprint: {}
    });
    state.addKey = null;
  },
  SET_IS_ROADMAP(state, data) {
    state.isRoadmap = data;
  },
  INIT_FILTER(state) {
    state.projectView = Object.assign({}, state.projectView, {
      epic: {},
      sprint: {},
      issue: {},
      subtask: {}
    });
    state.versionView = Object.assign({}, state.versionView, {
      epic: {},
      sprint: {},
      issue: {},
      subtask: {}
    });
  },
  TOGGLE_EXPAND(state, uid) {
    if (!uid) {
      return;
    }
    const expands = new Set(state.expands);
    if (expands.has(uid)) {
      expands.delete(uid);
    } else {
      expands.add(uid);
    }
    state.expands = [...expands];
  },
  TOGGLE_EXPAND_ALL_ROOT(state, isExpand){
    const { view } = state.filterSelected;
    if (!isExpand){
      state.expands = state.expands.filter(item => !item.includes(view));
      state.shouldUpdateUuids = [];
      return;
    }
    const list = view === 'project' ? state.projectView?.list : state.versionView?.list;
    const expands = new Set(state.expands);
    const shouldUpdateUuids = new Set(state.shouldUpdateUuids);
    list.forEach(
      item => {
        const canExpand = () => {
          const { type, epicCount, sprintCount, issueCount } = item;
          if (['project', 'version'].includes(type)) {
            if (state.filterSelected.item === 'epic') {
              return !!(epicCount || issueCount);
            }
            if (state.filterSelected.item === 'sprint') {
              return !!(sprintCount || issueCount);
            }
          }
        };
        if (canExpand()){
          isExpand ? expands.add(item.uid) : expands.delete(item.uid);
          isExpand ? shouldUpdateUuids.add(item.uid) : shouldUpdateUuids.delete(item.uid);
        }
      }
    );
    state.expands = [...expands];
    state.shouldUpdateUuids = [...shouldUpdateUuids];
  },
  SET_EXPANDS(state, value){
    state.expands = value || [];
  },
  CLEAR_SUBTASK_EXPANDS(state) {
    state.expands = state.expands.filter(uid => !uid.startsWith('issue_'));
  },
  TOGGLE_EXPAND_ROOT(state, { isExpand, list }){
    const expands = new Set(state.expands);
    const shouldUpdateUuids = new Set(state.shouldUpdateUuids);
    list.forEach(
      item => {
        if (item.issueCount){
          isExpand ? expands.add(item.uid) : expands.delete(item.uid);
          isExpand ? shouldUpdateUuids.add(item.uid) : shouldUpdateUuids.delete(item.uid);
        }
      }
    );
    state.expands = [...expands];
    state.shouldUpdateUuids = [...shouldUpdateUuids];
  },
  SET_DATE_RANGE(state, direction) {
    if (direction === 'left') {
      const start = state.dateList[0].date;
      const newStart = dayjs(start)
        .subtract(1, 'day')
        .format('YYYY/MM/DD 00:00:00');
      state.dateList = [createDateItem(newStart), ...state.dateList];
      document.querySelector(`.${state.horizontalScrollerClass}`).scrollLeft = 1;
    }
    if (direction === 'right') {
      const end = state.dateList[state.dateList.length - 1].date;
      const newEnd = dayjs(end)
        .add(1, 'day')
        .format('YYYY/MM/DD 00:00:00');
      state.dateList = [...state.dateList, createDateItem(newEnd)];
      document.querySelector(`.${state.horizontalScrollerClass}`).scrollLeft = state.scrollLeft - 1;
    }
  },
  SET_PROJECT_VIEW(state, data) {
    setTimeout(
      () => {
        state.projectView = Object.assign({}, state.projectView, data);
      }, 16
    );
  },
  SET_VERSION_VIEW(state, data) {
    setTimeout(
      () => {
        state.versionView = {
          ...state.versionView,
          ...data
        };
      }, 16
    );
  },
  SET_IS_DRAGING(state, value) {
    state.isDragging = value;
  },
  SET_UPDATE_ITEMS(state, data) {
    state.shouldUpdateUuids = data || [];
  },
  ADD_UPDATE_ITEMS(state, uuids) {
    if (!uuids?.length) {
      return;
    }
    const shouldUpdateUuids = new Set(state.shouldUpdateUuids);
    uuids.forEach(uuid => shouldUpdateUuids.add(uuid));
    state.shouldUpdateUuids = [...shouldUpdateUuids];
  },
  DELETE_UPDATE_ITEMS(state, uuids) {
    if (!uuids?.length) {
      return;
    }
    const shouldUpdateUuids = new Set(state.shouldUpdateUuids);
    uuids.forEach(uuid => shouldUpdateUuids.delete(uuid));
    state.shouldUpdateUuids = [...shouldUpdateUuids];
  },
  SET_DATE_TYPE(state, value){
    state.dateType = value;
  },
  SET_PROJECT_ISSUE_TYPE_MAP(state, value){
    if (!value){
      return;
    }
    state.projectIssueTypeMap = {
      ...state.projectIssueTypeMap,
      ...value
    };
  },
  SET_PROJECT_EPIC_ISSUE_TYPE_MAP(state, value){
    if (!value){
      return;
    }
    state.projectEpicIssueTypeMap = {
      ...state.projectEpicIssueTypeMap,
      ...value
    };
  },
  SET_HIGHT_LIGHT_ITEM(state, value){
    state.highLightItem = value;
  },
  SET_ANIMATION(){
    // state.shouldAnimation = value;
    // if (value){
    //   setTimeout(() => {
    //     state.shouldAnimation = false;
    //   }, 2000);
    // }
  },
  SET_LINE_DRAGGING(state, value) {
    state.lineDragging = value;
  },
  SET_PROJECT_LOADED_RELATIONSHIP(state, data) {
    state.projectViewLoadedRelationshipObj = {
      ...state.projectViewLoadedRelationshipObj,
      ...data
    };
  },
  SET_VERSION_LOADED_RELATIONSHIP(state, data) {
    state.versionViewLoadedRelationshipObj = {
      ...state.versionViewLoadedRelationshipObj,
      ...data
    };
  },
  ADD_LOCAL_SPRINT(state, value) {
    if (!value){
      return;
    }
    if (state.filterSelected.view === 'project'){
      const sprint = formatSprintItem(value, { parentId: value.projectId });
      const sprints = state.projectView.sprint[sprint.projectId]?.filter(item => item.type !== 'empty') || [];
      sprints.unshift(sprint);
      state.projectView = Object.assign({}, state.projectView, {
        sprint:{
          ...state.projectView.sprint,
          [sprint.projectId]: sprints
        }
      });
    }
  },
  ADD_LOCAL_EPIC(state, value) {
    if (!value){
      return;
    }
    if (state.filterSelected.view === 'project'){
      const epic = formatEpicItem(value, { parentId: value.projectId });
      const epics = state.projectView.epic[epic.projectId]?.filter(item => item.type !== 'empty') || [];
      epics.unshift(epic);
      state.projectView = Object.assign({}, state.projectView, {
        epic:{
          ...state.projectView.epic,
          [epic.projectId]: epics
        }
      });
    }
  },
  ADD_LOCAL_ISSUE(state, value) {
    if (!value){
      return;
    }
    const issue = formatIssueItem(value, {
      pathId: value.pathId || value.id
    });
    if (state.filterSelected.view === 'project'){
      const issues = state.projectView.issue[issue.key]?.filter(item => item.type !== 'empty') || [];
      issues.unshift(issue);
      state.projectView = Object.assign({}, state.projectView, {
        issue:{
          ...state.projectView.issue,
          [issue.key]: issues
        }
      });
    }
  },
  SET_RELATIONSHIP_DATA(state, value) {
    state.relationShipDataList = value;
  },
  SET_CURRENT_DRAG_ITEM(state, value) {
    state.currentDragSourceId = value;
  }
};

const getUid = () => {
  // eslint-disable-next-line
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const SIZE = {
  0: 50,
  1: 46,
  2: 46,
  3: 46
};

const formatProjectItem = item => Object.freeze({
  ...item,
  type: 'project',
  key: item.id,
  level: 0,
  size: SIZE[0],
  showTimebar: true,
  editTimebar: true,
  startDate: item.calcStartDate || item.calcDueDate,
  endDate: item.calcDueDate || item.calcStartDate,
  reallyDate: [item.calcStartDate, item.calcDueDate],
  path: 'project',
  pathId: `${item.id}`,
  uid: `project.${item.id}`
});

const formatEpicItem = (item, parent) => {
  const { view } = state.filterSelected;
  return Object.freeze({
    ...item,
    type: 'epic',
    level: 1,
    size: SIZE[1],
    key: `${parent.parentId}.${item.id}`,
    showTimebar: true,
    editTimebar: !!item.id,
    startDate: item.startDate || item.dueDate,
    endDate: item.dueDate || item.startDate,
    reallyDate: [item.startDate, item.dueDate],
    uid: `${view}.${parent.parentId}_epic.${item.id}`,
    pathId: `${parent.parentId}.${item.id}`,
    ...parent
  });
};

const formatSprintItem = (item, parent) => {
  const { view } = state.filterSelected;
  return Object.freeze({
    ...item,
    type: 'sprint',
    level: 1,
    size: SIZE[1],
    key: `${parent.parentId}.${item.id}`,
    showTimebar: true,
    editTimebar: !!item.id,
    iconUrl: item.id > 0 ? 'icondiedai1' : '',
    startDate: item.startDate || item.endDate,
    endDate: item.endDate || item.startDate,
    reallyDate: [item.startDate, item.endDate],
    pathId: `${parent.parentId}.${item.id}`,
    uid: `${view}.${parent.parentId}_sprint.${item.id}`,
    ...parent
  });
};

const formatIssueItem = (item, other = {}) => Object.freeze({
  ...item,
  type: 'issue',
  level: 2,
  size: SIZE[2],
  showTimebar: true,
  editTimebar: true,
  startDate: item.beginDate || item.endDate,
  endDate: item.endDate || item.beginDate,
  reallyDate: [item.beginDate, item.endDate],
  uid: `issue_${other.pathId}`,
  ...other
});

const formatSubtaskItem = (item, other = {}) => Object.freeze({
  ...item,
  name: item.name || item.summary,
  type: 'subtask',
  level: 3,
  size: SIZE[3],
  showTimebar: true,
  editTimebar: true,
  startDate: item.beginDate || item.startDate || item.endDate || item.dueDate,
  endDate: item.endDate || item.dueDate || item.beginDate || item.startDate,
  reallyDate: [item.beginDate || item.startDate, item.endDate || item.dueDate],
  stateCategory: item.stateCategory || item.status?.stateCategory,
  uid: `subtask_${other.pathId}`,
  ...other
});

const formatVersionItem = item => {
  const startDate = item.startDate;
  const endDate = item.statusVO?.status === 'release' ? item.releasedDate : item.planDate;
  return Object.freeze({
    ...item,
    type: 'version',
    level: 0,
    key: item.id,
    size: SIZE[0],
    showTimebar: true,
    editTimebar: item.statusVO?.status !== 'release',
    startDate: startDate || endDate,
    endDate: endDate || startDate,
    reallyDate: [startDate, endDate],
    iconUrl: 'iconbanben1',
    issueCount:
        item.todoIssueCount + item.doingIssueCount + item.doneIssueCount,
    path: 'version',
    pathId: `${item.id}`,
    uid: `version.${item.id}`
  });
};

const emptyObj = data => Object.freeze({
  type: 'empty',
  id: Math.random(),
  size: data.level === 0 ? 400 : SIZE[data.level],
  uid: getUid(),
  ...data
});

const getIssueTypeIds = (issueTypeVOS, issueTypeList) => {
  const allIssueType = groupBy(issueTypeVOS, 'projectId');
  const selected = groupBy(issueTypeVOS.filter(item => issueTypeList.includes(item.id)), 'projectId');
  const selectedIssueTypeGroupByProject = { ...allIssueType, ...selected };
  return Object.values(selectedIssueTypeGroupByProject).flat().map(item => item.id);
};

const PATH_API = {
  project: 'getRoadmapProjectList',
  'project.epic': 'getProjectEpicList',
  'project.sprint': 'getProjectSprintList',
  'project.epic.issue': 'getProjectEpicIssueList',
  'project.sprint.issue': 'getProjectSprintIssueList',
  version: 'getVersionListByVersionViewMode',
  'version.epic': 'getVersionEpicList',
  'version.sprint': 'getVersionSprintList',
  'version.epic.issue': 'getVersionEpicIssueList',
  'version.sprint.issue': 'getVersionSprintIssueList'
};

const actions = {
  async getRoadmapProjectList({ commit }, params = {}) {
    const data = (await getRoadmapProjectList(params)) || [];
    let list = data?.map(formatProjectItem);
    if (!list?.length) {
      list = [emptyObj({ level: 0 })];
    }
    commit('SET_PROJECT_VIEW', { list: list });
    return list;
  },
  async getProjectEpicList({ commit, state }, params = {}) {
    const data = await getRoadmapProjectEpicList(params);
    let list = data?.map(item => formatEpicItem(item, { parentId: params.projectId, path: 'project.epic' })
    );
    if (!list?.length) {
      list = [emptyObj({ level: 1, path: 'project.epic', pathId: params.projectId })];
    }
    if (params.keepOld) {
      const oldList = state.projectView?.epic?.[params.projectId];
      list = handleKeepOld(oldList, list, params.keepOldFilters);
    }
    commit('SET_PROJECT_VIEW', {
      epic: {
        ...state.projectView.epic,
        [params.projectId]: list
      }
    });
    return list;
  },
  async getProjectSprintList({ commit }, params = {}) {
    const data = await getSprintByProjectViewMode(params);
    let list = data?.map(item => formatSprintItem(item, {
      parentId: params.projectId,
      path: 'project.sprint'
    })
    );
    if (!list?.length) {
      list = [emptyObj({ level: 1, path: 'project.sprint', pathId: `${params.projectId}` })];
    }
    commit('SET_PROJECT_VIEW', {
      sprint: {
        ...state.projectView.sprint,
        [params.projectId]: list
      }
    });
    return list;
  },
  async getRoadMapFilters({ commit }, params) {
    const res = await getRoadmapFilters(params);
    commit('SET_FILTER_OPTIONS', res);
  },
  async getProjectEpicIssueList({ commit }, params = {}) {
    const data = await getEpicIssueByProjectViewMode(params);
    const key = `${params.projectId}.${params.epicId}`;
    let list = data?.list?.map(item => formatIssueItem(item, {
      projectId: params.projectId,
      epicId: params.epicId,
      path: 'project.epic.issue',
      pathId: params.projectId + '.' + params.epicId + '.' + item.id,
      key
    })
    );
    if (params.keepOld){
      const oldList = state.projectView?.issue?.[key];
      list = handleKeepOld(oldList, list, params.keepOldFilters);
    }
    if (!list?.length) {
      list = [emptyObj({ level: 2 })];
    }
    commit('SET_PROJECT_VIEW', {
      issue: {
        ...state.projectView.issue,
        [key]: list
      }
    });
  },
  async getProjectSprintIssueList({ commit }, params = {}) {
    const data = await getSprintIssueByProjectViewMode(params);
    const key = `${params.projectId}.${params.sprintId}`;
    let list = data?.list?.map(item => formatIssueItem(item, {
      projectId: params.projectId,
      sprintId: params.sprintId,
      path: 'project.sprint.issue',
      pathId: params.projectId + '.' + params.sprintId + '.' + item.id,
      key
    })
    );
    if (params.keepOld){
      const oldList = state.projectView?.issue?.[key];
      list = handleKeepOld(oldList, list, params.keepOldFilters);
    }
    if (!list?.length) {
      list = [emptyObj({ level: 2 })];
    }
    commit('SET_PROJECT_VIEW', {
      issue: {
        ...state.projectView.issue,
        [key]: list
      }
    });
  },
  async getVersionListByVersionViewMode({ commit }, params = {}) {
    const data = await getVersionListByVersionViewMode(params);
    let list = data?.map(formatVersionItem);
    if (!list?.length) {
      list = [emptyObj({ level: 0 })];
    }
    commit('SET_VERSION_VIEW', { list: list });
  },
  async getVersionEpicList({ commit }, params = {}) {
    const data = await getEpicListByVersionViewMode(params);
    let list = data?.map(item => formatEpicItem(item, { parentId: params.versionId, path: 'version.epic' })
    );
    if (!list?.length) {
      list = [emptyObj({ level: 1 })];
    }
    if (params.keepOld){
      const oldList = state.versionView?.epic?.[params.versionId];
      list = handleKeepOld(oldList, list, params.keepOldFilters);
    }
    commit('SET_VERSION_VIEW', {
      epic: {
        ...state.versionView.epic,
        [params.versionId]: list
      }
    });
    return list;
  },
  async getVersionSprintList({ commit }, params = {}) {
    const data = await getSprintListByVersionViewMode(params);
    let list = data?.map(item => formatSprintItem(item, {
      parentId: params.versionId,
      path: 'version.sprint'
    })
    );
    if (!list?.length) {
      list = [emptyObj({ level: 1 })];
    }
    commit('SET_VERSION_VIEW', {
      sprint: {
        ...state.versionView.sprint,
        [params.versionId]: list
      }
    });
    return list;
  },
  async getVersionEpicIssueList({ commit }, params = {}) {
    const data = await getEpicIssueListByVersionViewMode(params);
    const key = `${params.versionId}.${params.epicId}`;
    let list = data?.list?.map(item => formatIssueItem(item, {
      versionId: params.versionId,
      epicId: params.epicId,
      path: 'version.epic.issue',
      pathId: params.versionId + '.' + params.epicId + '.' + item.id,
      key
    })
    );
    if (params.keepOld){
      const oldList = state.versionView?.issue?.[key];
      list = handleKeepOld(oldList, list, params.keepOldFilters);
    }
    if (!list?.length) {
      list = [emptyObj({ level: 2 })];
    }
    commit('SET_VERSION_VIEW', {
      issue: {
        ...state.versionView.issue,
        [key]: list
      }
    });
  },
  async getVersionSprintIssueList({ commit }, params = {}) {
    const data = await getSprintIssueListByVersionViewMode(params);
    const key = `${params.versionId}.${params.sprintId}`;
    let list = data?.list?.map(item => formatIssueItem(item, {
      versionId: params.versionId,
      sprintId: params.sprintId,
      path: 'version.sprint.issue',
      pathId: params.versionId + '.' + params.sprintId + '.' + item.id,
      key
    })
    );
    if (params.keepOld){
      const oldList = state.versionView?.issue?.[key];
      list = handleKeepOld(oldList, list, params.keepOldFilters);
    }
    if (!list?.length) {
      list = [emptyObj({ level: 2 })];
    }
    commit('SET_VERSION_VIEW', {
      issue: {
        ...state.versionView.issue,
        [key]: list
      }
    });
  },
  handleBatchUpdate({ dispatch }, params) {
    clearTimeout(timer);
    const { pathId, path, uid } = params;
    batchUpdates.add(`${path}@@${pathId}@@${uid}`);
    timer = setTimeout(
      () => {
        if (batchUpdates.size){
          dispatch('requestBatchUpdate', [...batchUpdates]);
        }
        batchUpdates.clear();
        clearTimeout(timer);
      }, 100
    );
  },
  async requestBatchUpdate({ dispatch, commit }, params){
    if (!params?.length){
      return;
    }
    const updatedUuids = [];
    const requests = [];
    params.forEach(
      (item) => {
        const [, pathId, uid] = item.split('@@');
        const pathIds = pathId.split('.');
        requests.push(pathIds);
        updatedUuids.push(uid);
      });

    const { view, item } = state.filterSelected;
    if (view === 'project'){
      const dispatchAction = item === 'epic' ? 'getBatchProjectEpics' : 'getBatchProjectSprints';
      await dispatch(dispatchAction, requests);
    }
    if (view === 'version'){
      const dispatchAction = item === 'epic' ? 'getBatchVersionEpics' : 'getBatchVersionSprints';
      await dispatch(dispatchAction, requests);
    }
    commit('DELETE_UPDATE_ITEMS', updatedUuids);
  },
  async getBatchVersionEpics({ commit }, data = []) {
    const versionIds = [];
    const epicIds = [];
    const notRelates = [];
    data.forEach(
      item =>{
        const [versionId, epicId] = item || [];
        if (versionId && !versionIds.includes(Number(versionId))){
          versionIds.push(Number(versionId));
        }
        if (epicId && !epicIds.includes(Number(epicId))) {
          epicIds.push(Number(epicId));
        }
        if (epicId < 0 && !notRelates.includes(Number(versionId))){
          notRelates.push(Number(versionId));
        }
      }
    );
    const { epicStatus, category, issueType, epicOwner, blockShow, orderBy: roadmapOrderBy, overdueShow, onlyOverdueShow, issuePriorityIds, epicPriorityIds } = state.filterSelected;
    const params = {
      epicId: 0,
      versionIds: versionIds,
      epicIds: epicIds,
      epicStatusIds: epicStatus || [],
      categoryIds: category || [],
      issueTypeIds: getIssueTypeIds(state.filterOptions.issueTypeVOS, issueType),
      epicOwnerIds: epicOwner || [],
      blockShow: blockShow || true,
      overdueShow,
      onlyOverdueShow,
      notRelates,
      pageNum: 1,
      pageNumber: 1,
      pageSize: 9999,
      issuePriorityIds,
      epicPriorityIds,
      orderBy: {
        field: roadmapOrderBy.orderBy,
        desc: typeof roadmapOrderBy.desc === 'boolean' ? roadmapOrderBy.desc : roadmapOrderBy.desc === 'true'
      }
    };
    const { versionEpicIssueMap, versionEpicMap } = await getBatchVersionEpics(params);
    const obj = {
      epic: {},
      issue: {}
    };
    versionIds.forEach(versionId => {
      const key = `${versionId}`;
      let list = versionEpicMap[versionId]?.map(item => formatEpicItem(item, { parentId: +key, path: 'version.epic' }));
      if (!list?.length) {
        list = [emptyObj({ level: 1, path: 'version.epic', pathId: key })];
      }
      obj.epic[key] = list;
      epicIds.forEach(
        epicId => {
          const key = `${versionId}.${epicId}`;
          let list = versionEpicIssueMap[versionId]?.[epicId]?.list?.map(item => formatIssueItem(item, {
            versionId: versionId,
            epicId: epicId,
            path: 'version.epic.issue',
            pathId: versionId + '.' + epicId + '.' + item.id,
            key
          }));
          if (!list?.length) {
            list = [emptyObj({ level: 2 })];
          }
          obj.issue[key] = list;
        }
      );
    });
    commit('SET_VERSION_VIEW', {
      epic: {
        ...state.versionView.epic,
        ...obj.epic
      },
      issue: {
        ...state.versionView.issue,
        ...obj.issue
      }
    });
  },
  async getBatchVersionSprints({ commit }, data = []) {
    const versionIds = [];
    const sprintIds = [];
    const notRelates = [];
    data.forEach(
      item =>{
        const [versionId, sprintId] = item || [];
        if (versionId && !versionIds.includes(Number(versionId))){
          versionIds.push(Number(versionId));
        }
        if (sprintId && !sprintIds.includes(Number(sprintId))){
          sprintIds.push(Number(sprintId));
        }
        if (sprintId < 0 && !notRelates.includes(Number(versionId))){
          notRelates.push(Number(versionId));
        }
      }
    );
    const { sprintStatus, category, issueType, sprintOwner, blockShow, orderBy: roadmapOrderBy, overdueShow, onlyOverdueShow, issuePriorityIds } = state.filterSelected;
    const params = {
      sprintId: 0,
      versionIds: versionIds,
      sprintIds: sprintIds,
      sprintStatusIds: sprintStatus || [],
      categoryIds: category || [],
      issueTypeIds: getIssueTypeIds(state.filterOptions.issueTypeVOS, issueType),
      sprintOwnerIds: sprintOwner || [],
      blockShow: blockShow || true,
      overdueShow,
      onlyOverdueShow,
      notRelates,
      pageNum: 1,
      pageNumber: 1,
      pageSize: 9999,
      issuePriorityIds,
      orderBy: {
        field: roadmapOrderBy.orderBy,
        desc: typeof roadmapOrderBy.desc === 'boolean' ? roadmapOrderBy.desc : roadmapOrderBy.desc === 'true'
      }
    };
    const { versionSprintIssueMap, versionSprintMap } = await getBatchVersionSprints(params);
    const obj = {
      sprint: {},
      issue: {}
    };
    versionIds.forEach(versionId => {
      const key = `${versionId}`;
      let list = versionSprintMap[versionId]?.map(item => formatSprintItem(item, { parentId: +key, path: 'version.sprint' }));
      if (!list?.length) {
        list = [emptyObj({ level: 1, path: 'version.sprint', pathId: key })];
      }
      obj.sprint[key] = list;
      sprintIds.forEach(
        sprintId => {
          const key = `${versionId}.${sprintId}`;
          let list = versionSprintIssueMap[versionId]?.[sprintId]?.list?.map(item => formatIssueItem(item, {
            versionId: versionId,
            sprintId: sprintId,
            path: 'version.sprint.issue',
            pathId: versionId + '.' + sprintId + '.' + item.id,
            key
          }));
          if (!list?.length) {
            list = [emptyObj({ level: 2 })];
          }
          obj.issue[key] = list;
        }
      );
    });
    commit('SET_VERSION_VIEW', {
      sprint: {
        ...state.versionView.sprint,
        ...obj.sprint
      },
      issue: {
        ...state.versionView.issue,
        ...obj.issue
      }
    });
  },
  async getBatchProjectEpics({ commit }, data = []) {
    const projectIds = [];
    const epicIds = [];
    const notRelates = [];
    data.forEach(
      item =>{
        const [projectId, epicId] = item || [];
        if (projectId && !projectIds.includes(Number(projectId))){
          projectIds.push(Number(projectId));
        }
        if (epicId && !epicIds.includes(Number(epicId))) {
          epicIds.push(Number(epicId));
        }
        if (epicId < 0 && !notRelates.includes(Number(projectId))){
          notRelates.push(Number(projectId));
        }
      }
    );
    const { epicStatus, category, issueType, epicOwner, blockShow, orderBy: roadmapOrderBy, overdueShow, onlyOverdueShow, epicPriorityIds, issuePriorityIds } = state.filterSelected;
    const params = {
      epicId: 0,
      projectIds: projectIds,
      epicIds: epicIds,
      epicStatusIds: epicStatus || [],
      categoryIds: category || [],
      issueTypeIds: getIssueTypeIds(state.filterOptions.issueTypeVOS, issueType),
      epicOwnerIds: epicOwner || [],
      blockShow: blockShow || true,
      overdueShow,
      onlyOverdueShow,
      notRelates,
      pageNum: 1,
      pageNumber: 1,
      pageSize: 9999,
      epicPriorityIds,
      issuePriorityIds,
      orderBy: {
        field: roadmapOrderBy.orderBy,
        desc: typeof roadmapOrderBy.desc === 'boolean' ? roadmapOrderBy.desc : roadmapOrderBy.desc === 'true'
      }
    };
    const { projectEpicIssueMap, projectEpicMap } = await getBatchProjectEpics(params);
    const obj = {
      epic: {},
      issue: {}
    };
    projectIds.forEach(projectId => {
      const key = `${projectId}`;
      let list = projectEpicMap[projectId]?.map(item => formatEpicItem(item, { parentId: +key, path: 'project.epic' }));
      if (!list?.length) {
        list = [emptyObj({ level: 1, path: 'project.epic', pathId: key })];
      }
      obj.epic[key] = list;
      epicIds.forEach(
        epicId => {
          const key = `${projectId}.${epicId}`;
          let list = projectEpicIssueMap[projectId]?.[epicId]?.list?.map(item => formatIssueItem(item, {
            projectId: projectId,
            epicId: epicId,
            path: 'project.epic.issue',
            pathId: projectId + '.' + epicId + '.' + item.id,
            key
          }));
          if (!list?.length) {
            list = [emptyObj({ level: 2 })];
          }
          obj.issue[key] = list;
        }
      );
    });
    commit('SET_PROJECT_VIEW', {
      epic: {
        ...state.projectView.epic,
        ...obj.epic
      },
      issue: {
        ...state.projectView.issue,
        ...obj.issue
      }
    });
  },
  async getBatchProjectSprints({ commit }, data = []) {
    const projectIds = [];
    const sprintIds = [];
    const notRelates = [];
    data.forEach(
      item =>{
        const [projectId, sprintId] = item || [];
        if (projectId && !projectIds.includes(Number(projectId))){
          projectIds.push(Number(projectId));
        }
        if (sprintId && !sprintIds.includes(Number(sprintId))) {
          sprintIds.push(Number(sprintId));
        }
        if (sprintId < 0 && !notRelates.includes(Number(projectId))){
          notRelates.push(Number(projectId));
        }
      }
    );
    const { sprintStatus, category, issueType, sprintOwner, blockShow, orderBy: roadmapOrderBy, overdueShow, onlyOverdueShow, issuePriorityIds } = state.filterSelected;
    const params = {
      epicId: 0,
      projectIds: projectIds,
      sprintIds,
      sprintStatusIds: sprintStatus || [],
      categoryIds: category || [],
      issueTypeIds: getIssueTypeIds(state.filterOptions.issueTypeVOS, issueType),
      sprintOwnerIds: sprintOwner || [],
      blockShow: blockShow || false,
      overdueShow,
      onlyOverdueShow,
      notRelates,
      pageNum: 1,
      pageNumber: 1,
      pageSize: 9999,
      issuePriorityIds,
      orderBy: {
        field: roadmapOrderBy.orderBy,
        desc: typeof roadmapOrderBy.desc === 'boolean' ? roadmapOrderBy.desc : roadmapOrderBy.desc === 'true'
      }
    };
    const { projectSprintIssueMap, projectSprintMap } = await getBatchProjectSprints(params);
    const obj = {
      sprint: {},
      issue: {}
    };
    projectIds.forEach(projectId => {
      const key = `${projectId}`;
      let list = projectSprintMap[projectId]?.map(item => formatSprintItem(item, { parentId: +key, path: 'project.sprint' }));
      if (!list?.length) {
        list = [emptyObj({ level: 1, path: 'project.sprint', pathId: key })];
      }
      obj.sprint[key] = list;
      sprintIds.forEach(
        sprintId => {
          const key = `${projectId}.${sprintId}`;
          let list = projectSprintIssueMap[projectId]?.[sprintId]?.list?.map(item => formatIssueItem(item, {
            projectId: projectId,
            sprintId: sprintId,
            path: 'project.sprint.issue',
            pathId: projectId + '.' + sprintId + '.' + item.id,
            key
          }));
          if (!list?.length) {
            list = [emptyObj({ level: 2 })];
          }
          obj.issue[key] = list;
        }
      );
    });
    commit('SET_PROJECT_VIEW', {
      sprint: {
        ...state.projectView.sprint,
        ...obj.sprint
      },
      issue: {
        ...state.projectView.issue,
        ...obj.issue
      }
    });
  },
  async getRoadmapData({ dispatch, state, commit }, { path, pathId, keepOld, keepOldFilters }) {
    const {
      view,
      item,
      version,
      project,
      sprintStatus,
      epicStatus,
      category,
      issueType,
      orderBy: roadmapOrderBy,
      overdueShow,
      onlyOverdueShow,
      epicOwner,
      sprintOwner,
      blockShow,
      epicPriorityIds,
      issuePriorityIds
    } = state.filterSelected;
    let params = {};
    let apiPath = '';
    if (!path) {
      apiPath = view;
    } else if (path.split('.').length === 1) {
      apiPath = `${path}.${item}`;
    } else if (path.split('.').length === 2) {
      apiPath = `${path}.issue`;
    }
    const pathIds = String(pathId)
      ?.split('.')
      ?.map(id => +id);
    const pages = {
      pageNum: 1,
      pageNumber: 1,
      pageSize: 9999
    };
    switch (apiPath) {
      case 'version':
        params = {
          versionIds: version || [],
          projectIds: project || [],
          epicStatusIds: epicStatus || [],
          sprintStatusIds: sprintStatus || [],
          categoryIds: category || [],
          issueTypeIds: issueType || [],
          epicOwnerIds: epicOwner || [],
          sprintOwnerIds: sprintOwner || [],
          blockShow: blockShow || false,
          hierarchy: item
        };
        break;
      case 'project':
        params = {
          projectIds: project || [],
          epicStatusIds: epicStatus || [],
          sprintStatusIds: sprintStatus || [],
          categoryIds: category || [],
          epicOwnerIds: epicOwner || [],
          sprintOwnerIds: sprintOwner || [],
          blockShow: blockShow || false,
          hierarchy: item
        };
        if (issueType?.length){
          const { issueTypeVOS } = state.filterOptions;
          const selectIssueTypeOption = issueTypeVOS.filter(item => issueType.includes(item.id));
          const mapType = groupBy(selectIssueTypeOption, 'projectId');
          Object.keys(mapType).forEach(
            key => {
              mapType[key] = mapType[key].map(item => item.id);
            }
          );
          params.mapTypeIds = mapType;
        }
        break;
      case 'project.epic':
        params = {
          projectId: pathIds[0],
          epicStatusIds: epicStatus || [],
          categoryIds: category || [],
          issueTypeIds: issueType || [],
          epicOwnerIds: epicOwner || [],
          blockShow: blockShow || false
        };
        break;
      case 'project.sprint':
        params = { projectId: pathIds[0],
          sprintStatusIds: sprintStatus || [],
          categoryIds: category || [],
          issueTypeIds: issueType || [],
          sprintOwnerIds: sprintOwner || [],
          blockShow: blockShow || false
        };
        break;
      case 'project.epic.issue':
        params = {
          projectId: pathIds[0],
          epicId: pathIds[1],
          sprintIds: [],
          sprintStatusIds: sprintStatus || [],
          categoryIds: category || [],
          issueTypeIds: issueType || [],
          blockShow: blockShow || false,
          ...pages
        };
        break;
      case 'project.sprint.issue':
        params = {
          projectId: pathIds[0],
          sprintId: pathIds[1],
          sprintIds: [],
          sprintStatusIds: sprintStatus || [],
          categoryIds: category || [],
          issueTypeIds: issueType || [],
          blockShow: blockShow || false,
          ...pages
        };
        break;
      case 'version.epic':
        params = { versionId: pathIds[0],
          epicStatusIds: epicStatus || [],
          categoryIds: category || [],
          issueTypeIds: issueType || [],
          epicOwnerIds: epicOwner || [],
          blockShow: blockShow || false
        };
        break;
      case 'version.sprint':
        params = { versionId: pathIds[0],
          sprintStatusIds: sprintStatus || [],
          categoryIds: category || [],
          issueTypeIds: issueType || [],
          sprintOwnerIds: sprintOwner || [],
          blockShow: blockShow || false
        };
        break;
      case 'version.epic.issue':
        params = {
          versionId: pathIds[0],
          epicId: pathIds[1],
          sprintIds: [],
          sprintStatusIds: sprintStatus || [],
          categoryIds: category || [],
          issueTypeIds: issueType || [],
          blockShow: blockShow || false,
          ...pages
        };
        break;
      case 'version.sprint.issue':
        params = {
          versionId: pathIds[0],
          sprintId: pathIds[1],
          sprintIds: [],
          sprintStatusIds: sprintStatus || [],
          categoryIds: category || [],
          issueTypeIds: issueType || [],
          blockShow: blockShow || false,
          ...pages
        };
        break;
    }
    const allIssueType = groupBy(state.filterOptions.issueTypeVOS, 'projectId');
    const selected = groupBy(state.filterOptions.issueTypeVOS.filter(item => issueType.includes(item.id)), 'projectId');
    const selectedIssueTypeGroupByProject = { ...allIssueType, ...selected };
    if ((apiPath.includes('epic') || apiPath.includes('sprint')) && view === 'project'){
      params.issueTypeIds = selectedIssueTypeGroupByProject[pathIds[0]]?.map(item => item.id) || [];
    }
    if (view === 'version'){
      params.issueTypeIds = Object.values(selectedIssueTypeGroupByProject).flat().map(item => item.id);
    }
    try {
      if (pathId && pathIds?.length){
        const rootData = view === 'project' ? state.projectView : state.versionView;
        const apiPathList = apiPath.split('.');
        const pathData = rootData[apiPathList[apiPathList.length - 1]][pathId];
        if (!pathData?.length){
          commit('ADD_LOADING_KEY', pathId);
        }
      }
      return await dispatch(PATH_API[apiPath], {
        ...params,
        keepOld,
        keepOldFilters,
        orderBy: {
          field: roadmapOrderBy.orderBy,
          desc: typeof roadmapOrderBy.desc === 'boolean' ? roadmapOrderBy.desc : roadmapOrderBy.desc === 'true'
        },
        epicPriorityIds,
        issuePriorityIds,
        overdueShow,
        onlyOverdueShow
      });
    } finally {
      setTimeout(
        () => {
          commit('REMOVE_LOADING_KEY', pathId);
        }
      );
    }
  },
  updateLocalData({ commit, getters, state }, params) {
    if (!params?.id) {
      return;
    }
    const item = getters.list.find(item => item.id === params.id);
    if (!item) {
      return;
    }
    const view = state.filterSelected.view;
    const viewKey = `${view}View`;
    const commitKey = `SET_${view.toLocaleUpperCase()}_VIEW`;
    if (item.level === 0) {
      const mainList = [...state[viewKey]?.list];
      const mainIndex = mainList.findIndex(item => item.id === params.id);
      mainList[mainIndex] = Object.freeze({
        ...mainList[mainIndex],
        ...params
      });
      commit(commitKey, {
        list: mainList
      });
      return;
    }
    const key = (item.type === 'issue' || item.type === 'subtask') ? item.key : item.parentId;
    const data = state[viewKey][item.type];
    const list = [...data[key]];
    const index = list.findIndex(item => item.id === params.id);
    list[index] = Object.freeze({ ...list[index], ...params });
    commit(commitKey, {
      [item.type]: {
        ...data,
        [key]: list
      }
    });
  },
  async loadIssueTypes({ commit }, params = {}) {
    if (params.type === 'epic') {
      const result = await getEpicIssueTypeList(params.projectId);
      commit('SET_PROJECT_EPIC_ISSUE_TYPE_MAP', ({ [params.projectId]: result || [] }));
    }
    if (params.type === 'project') {
      const result = await getIssueTypeList(params.projectId);
      commit('SET_PROJECT_ISSUE_TYPE_MAP', ({ [params.projectId]: result || [] }));
    }
  },
  setPosition({ commit, getters, state }, { direction, source }) {
    const el = document.querySelector(`.${state.horizontalScrollerClass}`);
    if (!el || !direction || !source){
      return;
    }
    const boundWidth = el.getBoundingClientRect().width;
    const scrollLeft = state.scrollLeft;
    const firstDate = state.dateList[0].date;
    const dayCellWidth = getters.dayCellWidth;
    const boundLeftDays = Math.round(scrollLeft / dayCellWidth);
    const boundRightDays = Math.round((scrollLeft + boundWidth) / dayCellWidth);
    const start = dayjs(firstDate).add(boundLeftDays, 'day').format('YYYY/MM/DD');
    const end = dayjs(firstDate).add(boundRightDays, 'day').format('YYYY/MM/DD');
    const { startDate, endDate } = source;
    let distance = 0;
    const padding = 50;
    if (direction === 'left'){
      distance = -getDiffDays(startDate, start) * dayCellWidth - padding;
    }
    if (direction === 'right'){
      distance = (getDiffDays(end, endDate) + 1) * dayCellWidth + padding;
    }
    commit('SET_ELEMENT_SCROLLLEFT', { scrollLeft: scrollLeft + distance, smooth: true });
  },
  async getRelationshipInfos({ commit }, { path, pathId }) {
    const view = path.split('.')[0];
    const item = path.split('.')[1];
    const pathIds = String(pathId)
      ?.split('.')
      ?.map(id => +id);
    const idParams = {
      [`${view}Id`]: pathIds[0],
      [`${item}Id`]: pathIds[1]
    };
    const {
      sprintStatus,
      epicStatus,
      category,
      issueType,
      epicOwner,
      sprintOwner,
      blockShow
    } = state.filterSelected;
    const params = {
      sprintStatusIds: sprintStatus || [],
      epicStatusIds: epicStatus || [],
      categoryIds: category || [],
      issueTypeIds: issueType || [],
      sprintOwnerIds: sprintOwner || [],
      epicOwnerIds: epicOwner || [],
      blockShow: blockShow || false,
      hierarchy: item,
      [`${view}Id`]: pathIds[0],
      [`${item}Id`]: pathIds[1] < 0 ? -1 : pathIds[1]
    };
    const allIssueType = groupBy(state.filterOptions.issueTypeVOS, 'projectId');
    const selected = groupBy(state.filterOptions.issueTypeVOS.filter(item => issueType.includes(item.id)), 'projectId');
    const selectedIssueTypeGroupByProject = { ...allIssueType, ...selected };
    if ((path.includes('epic') || path.includes('sprint')) && view === 'project'){
      params.issueTypeIds = selectedIssueTypeGroupByProject[pathIds[0]].map(item => item.id);
    }
    if (view === 'version'){
      params.issueTypeIds = Object.values(selectedIssueTypeGroupByProject).flat().map(item => item.id);
    }
    const result = await getRoadmapRelationship(params);
    switch (path) {
      case 'project.epic': case 'project.epic.issue':
        commit('SET_PROJECT_LOADED_RELATIONSHIP', {
          epic: {
            ...state.projectViewLoadedRelationshipObj.epic,
            [`${idParams.projectId}.${[idParams.epicId]}`]: result
          }
        });
        break;
      case 'project.sprint': case 'project.sprint.issue':
        commit('SET_PROJECT_LOADED_RELATIONSHIP', {
          sprint: {
            ...state.projectViewLoadedRelationshipObj.sprint,
            [`${idParams.projectId}.${[idParams.sprintId]}`]: result
          }
        });
        break;
      case 'version.epic': case 'version.epic.issue':
        commit('SET_VERSION_LOADED_RELATIONSHIP', {
          epic: {
            ...state.versionViewLoadedRelationshipObj.epic,
            [`${idParams.versionId}.${[idParams.epicId]}`]: result
          }
        });
        break;
      case 'version.sprint': case 'version.sprint.issue':
        commit('SET_VERSION_LOADED_RELATIONSHIP', {
          sprint: {
            ...state.versionViewLoadedRelationshipObj.sprint,
            [`${idParams.versionId}.${[idParams.sprintId]}`]: result
          }
        });
        break;
    }
  },
  async getSubtaskList({ commit, state }, { issueId, issuePathId }) {
    const data = await getSubtaskListByIssueId({ issueId });
    const view = state.filterSelected.view;
    const viewKey = `${view}View`;
    const commitKey = `SET_${view.toLocaleUpperCase()}_VIEW`;
    const list = (data || []).map(item => formatSubtaskItem(item, {
      parentIssueId: issueId,
      path: `${view}.${state.filterSelected.item}.issue.subtask`,
      pathId: `${issuePathId}.${item.id}`,
      key: issuePathId
    }));
    commit(commitKey, {
      subtask: {
        ...state[viewKey].subtask,
        [issuePathId]: list
      }
    });
    return list;
  },
  async toggleExpandAll({ dispatch, commit, state }, { isRootExpandAll, isExpand, source }) {
    if (isRootExpandAll){
      commit('TOGGLE_EXPAND_ALL_ROOT', isExpand);
      return;
    }
    const { id, path, pathId, uid } = source;
    commit('TOGGLE_EXPAND', uid);
    const data = state.filterSelected.view === 'project' ? state.projectView : state.versionView;
    let list = data[state.filterSelected.item][id];
    if (isExpand && !list?.length){
      list = await dispatch('getRoadmapData', { path, pathId, keepOld: false });
    }
    if (!list?.length){
      return;
    }
    commit('TOGGLE_EXPAND_ROOT', { isExpand, id, list: list.filter(item => item.type !== 'empty') });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};

function createDateList(start, end){
  const list = [];
  const diff = dayjs(end).diff(start, 'day');
  for (let i = 0; i <= diff; i++) {
    const date = dayjs(start)
      .add(i, 'day');
    list.push(createDateItem(date, i));

  }
  return Object.freeze(list);
}

function createDateItem(date){
  const month = dayjs(date).month();
  const year = dayjs(date).year();
  const week = dayjs(date).week();
  const quarter = dayjs(date).quarter();
  let weekYear = year;
  // 周跨年时候处理
  if (month === 0 && week > 10){
    weekYear--;
  }
  if (month === 11 && week === 1){
    weekYear++;
  }
  return Object.freeze({
    date: dayjs(date).format('YYYY/MM/DD 00:00:00'),
    month,
    year,
    quarter,
    week,
    year_month: `${year}_${month}`,
    year_week: `${weekYear}_${week}`,
    year_quarter: `${year}_${quarter}`
  });
}

function getDiffDays(start, end) {
  if (!(start && end)) {
    return;
  }
  const startDate = dayjs(start).format('YYYY-MM-DD');
  const endDate = dayjs(end).format('YYYY-MM-DD');
  return dayjs(endDate).diff(startDate, 'day', true);
}


function handleKeepOld(olds, news, keepOldFilters){
  if (!olds?.length || !news?.length) {
    return;
  }
  const level = olds?.[0]?.level || news?.[0]?.level;
  const emptyList = [emptyObj({ level })];
  let newList = news?.filter(item => !['loading', 'empty'].includes(item.type));
  const oldList = olds?.filter(item => !['loading', 'empty'].includes(item.type) && !keepOldFilters?.includes(item.id));
  if (!newList?.length) {
    if (!oldList?.length) {
      return emptyList;
    }
    return oldList;
  }
  if (oldList?.length){
    const newIds = newList.map(item => item.id);
    const keepStickList = oldList.filter(item => item.isKeepStick);
    const keeps = oldList.filter(item => !newIds.includes(item.id));
    if (keeps.length){
      keeps.forEach(
        item => {
          let index = oldList.findIndex(oldItem => oldItem.id === item.id);
          const newListLength = newList.length;
          index = newListLength < (index + 1) ? newListLength - 1 : index;
          newList.splice(index, 0, {
            ...item,
            isKeepOld: true,
            keepKey: 'filter'
          });
        }
      );
    }
    if (keepStickList.length){
      const stickIds = keepStickList.map(item => item.id);
      const data = groupBy(newList, item => stickIds.includes(item.id) ? 'stick' : 'notStick');
      const stickGroupList = data.stick || [];
      const notStickGroupList = data.notStick || [];
      let stickList = stickGroupList.map(item => ({ ...item, isKeepStick: true, isKeepOld: true, keepKey: 'sort' }));
      stickList = sortBy(stickList, item => stickIds.indexOf(item.id));
      newList = [...stickList, ...notStickGroupList];
    }
  }
  if (!newList?.length) {
    return emptyList;
  }
  return newList;
}
